import { createContext } from 'react';
import type { useGetRoleAccess } from 'src/hooks/queries/role-access/useGetRoleAccess';

type GetRoleAccessData = {
  role_access: NonNullable<ReturnType<typeof useGetRoleAccess>['roleAccess']>;
};

export const PermissionsContext = createContext<
  GetRoleAccessData['role_access'] | null
>(null);
